import React from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { axiosget } from "../../helpers/httprequest";
import "./index.css";
import ErrorResponse from "../../components/ErrorResponse";
import ReceiptHeader from "../../components/ReceiptHeader";
import { useQuery } from "@tanstack/react-query";

const AdmissionLetter = () => {
  const { id } = useParams();
  // const [bio, setbio] = React.useState();
  // const [loading, setloading] = React.useState(true);
  // const [error, seterror] = React.useState(0);
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceReceiptInfo"],
    queryFn: async () => {
      const req = await axiosget(`ms_applications/letter/${id}`);
      return req?.data;
    },
  });

  return (
    <>
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.message !== undefined && <ErrorResponse type={`danger`} message={data?.message} />}
      {data?.message === undefined && (
        <>
          <div className="container">
            <ReceiptHeader
              office={
                <>
                  Offer of {data?.find?.status === 1 ? "Provisional " : data?.find?.status === 2 ? "conditional " : ""}
                  admission
                </>
              }
            />

            <div className="letterto">
              <div className="">
                <b className="text-uppercase">
                  {data?.bio?.firstname} {data?.bio?.middlename} {data?.bio?.lastname}
                </b>
                <br />
                <span>
                  {data?.bio?.stateoforigin} {data?.bio?.lgaoforigin}
                </span>{" "}
                <br />
                JAMB: <b>{data?.find?.applicant?.jamb}</b>
              </div>
              <div className="">Date: {new Date().toDateString()}</div>
            </div>

            <div className="body">
              <div style={{ textAlign: "justify" }}>
                After considering your application for admission into the college, I am pleased to write on behalf of the Academic Board to offer you
                Admission to study <b>{data?.find?.programme?.name}</b> {` `}
                in the <b>{data?.find?.programme?.department?.name}</b>, {data?.find?.programme?.department?.college?.name} in the{" "}
                {data?.find?.session?.name} beginning immediately on the condition that:-
              </div>
              <ul id="letter">
                <li>
                  <b>Duration of Course: {data?.find?.type === "UTME" ? 4 : 3} year(s)</b>
                </li>
                <li>The particulars provided in your application form are correct in every respect.</li>
                <li>
                  You will present at the time of Registration the original copies of the credentials listed in your application for scrutiny. SSCE
                  result slip or its equivalent will be accepted in lieu of certificate
                </li>
                <li>
                  If at any time, even after your registration it is discovered that you do not satisfy the minimum requirements prescribed for
                  admission for your course of study at the time of this offer, or at that any of the qualifications you purported to have had is
                  false, or incorrectly quoted, or that any other information you provided is false or incorrect, you will be withdrawn from the
                  College.
                </li>
                <li>You will abide by all the rules and regulations of the College</li>
                <li>
                  You will accept any disciplinary action taken against you by the college management if you are found to have contravened any of the
                  rules and regulations of the College
                </li>
                <li>
                  The name by which you are hereby admitted and by which you will be registered is the one which will appear in any certificate that
                  the College may issue to you on successful completion of your course
                </li>
                <li>This offer is not transferable to another session unless it is approved.</li>
                <li>The Management may decide to withdraw the admission offered you anytime at its discretion.</li>
                <li>
                  Your Admission number shall be given to you after screening and payment of approved fees. Please quote this number in any
                  correspondence on this offer between now and time of registration. You are also required to send in an acceptance letter for the
                  offer within two weeks of the date on the admission letter failing which it shall be deemed to have lapsed. No candidate will be
                  attended to, after the closure of the registration exercise.
                </li>
                <li>
                  If you accept this offer, you will be required to pay a non-refundable registration fee as per the attached scheduled of fees at the
                  time of registration. You are also required to note that the College shall not enter into negotiation with any Scholarship Board or
                  Government Ministry on behalf of any candidate in respect of the mode of payment of fees.
                </li>
                <li>
                  Accommodation will be made available on the payment of appropriate fees on the basis of first come first served. However, the
                  College does not guarantee the availability of accommodation arrangement elsewhere.
                </li>
                {/* <li>
                    All admitted candidates will be required to submit a Medical
                    Certificate of fitness duly signed by a Medical Doctor from
                    a recognized Government/Private Hospital before they are
                    registered.
                  </li> */}
                <li>
                  <b>
                    <u>
                      Candidates should note that this provisional admission is subject to production of JAMB (DE) results for either 2021/2022 or
                      2022/2023 Academic session.
                    </u>
                  </b>
                </li>
              </ul>
              <div className="text-center">
                Accept my congratulations.
                <br />
                <br />
                <img src="../images/reg.png" alt="Registrar Signature" />
                <br />
                <b>
                  Alh. Sambo Aliyu, <small style={{ fontSize: 9 }}>MNIM, FIICA (Danlawal of Jama’are)</small>
                  <br />
                  Registrar
                </b>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdmissionLetter;
